import { makeStyles, Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import { addHTTP } from 'utils/utils'

const useStyles = makeStyles(() => ({
  button: {
    marginBottom: '10px',
    marginTop: '10px',
    backgroundColor: 'var(--button-color)',
    color: 'var(--button-text-color)',
    '&:hover': {
      backgroundColor: 'var(--button-color)',
    }
  },
}))


export default function RenderLink(props) {
  const classes = useStyles()
  const { elmIndex, elm } = props
  return <div key={elmIndex}>
    {(elm.URL || elm.Prompt) && <Button size="large" className={classes.button} href={addHTTP(elm.URL)} target='_blank'>{elm.Prompt}</Button>}
  </div>
}

RenderLink.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
}